import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { DocumentType } from '~/monolith-api';

export type AddDocumentsToScheduleOptions = CommonRequestOptions & {
   prsid: number;
   docs: DocumentType[];
   due_date?: number;
};

export function addDocumentsToSchedule({
   prsid,
   docs,
   due_date,
   ...common
}: AddDocumentsToScheduleOptions): Promise<void> {
   return makeRequest('post', `periodic_review/documents`, {
      ...common,
      body: {
         prsid,
         docs,
         due_date,
      },
   });
}
